import React, { useRef, useEffect, useState, useMemo } from 'react'
import { Map, Marker, GoogleApiWrapper, InfoWindow } from 'google-maps-react'
import PropTypes from 'prop-types'
import isNumber from 'lodash/isNumber'
import MarkerImg from 'assets/icons/marker.png'
import { connect } from 'react-redux'

const API_KEY = process.env.GEO_API_KEY_FE

const BuildingMap = ({ details, zoom = 16, google }) => {
  const gMap = useRef(null)
  const { id, name, building_information = {}, address } = details
  const location = building_information.location || {}
  const { lat, lng } = location
  const [showInfoWindow, setShowInfoWindow] = useState(false)
  const [activeMarker, setActiveMarker] = useState({})

  const locationEnable = useMemo(() => {
    return isNumber(lat) && isNumber(lng)
  }, [location])

  useEffect(() => {
    locationEnable && gMap.current.map.setCenter({ lat, lng })
  }, [locationEnable])

  return (
    <Map
      ref={gMap}
      google={google}
      zoom={zoom}
      fullscreenControl={false}
      zoomControlOptions={{ position: google.maps.ControlPosition.TOP_LEFT }}
      streetViewControl={false}
      mapTypeControlOptions={{
        position: google.maps.ControlPosition.TOP_RIGHT,
      }}
      onClick={(e) => {
        console.log(e)
      }}
      initialCenter={{
        lat: 1.3139961,
        lng: 103.7041631,
      }}
    >
      {locationEnable && (
        <Marker
          key={id}
          title={name}
          options={{
            icon: {
              url: MarkerImg,
              anchor: new google.maps.Point(32, 32),
              scaledSize: new google.maps.Size(64, 64),
            },
            scrollwheel: false,
            zoom: 13,
          }}
          position={{ lat, lng }}
          onClick={(markerProps, marker) => {
            setActiveMarker(marker)
            setShowInfoWindow(true)
          }}
        />
      )}
      <InfoWindow marker={activeMarker} visible={showInfoWindow}>
        <div>
          <h4 className="text-primary-black">{name}</h4>
          <p className="text-primary-black address">{address}</p>
        </div>
      </InfoWindow>
    </Map>
  )
}

BuildingMap.propTypes = {
  zoom: PropTypes.number,
  google: PropTypes.object,
  details: PropTypes.object,
}

const mapStateToProps = ({ building }) => ({
  details: building.public.details,
})

export default connect(mapStateToProps)(
  GoogleApiWrapper({
    apiKey: API_KEY,
    v: '3',
  })(BuildingMap)
)
